'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _constants = require('../../constants');

var _ContactUsForm = require('./ContactUsForm.scss');var styles = _interopRequireWildcard(_ContactUsForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers
// Modules
var bottomBlock = function bottomBlock(properties) {var _cx, _cx2;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(
        styles.bottomBlock, (_cx = {}, _cx[
        styles.projectsContactUsForm] = properties.usage === _constants.contactUsUsage.projects, _cx), (_cx2 = {}, _cx2[
        styles.realtorPackagesContactUsForm] = properties.usage === _constants.contactUsUsage.realtorPackages, _cx2)) },


      _react2.default.createElement('div', null,
        _react2.default.createElement(_components.GoogleReCaptcha, {
            locale: properties.locale,
            fetchToken: properties.fetchReCaptchaToken },

          _react2.default.createElement(_components.OMButtonWithPreloader, {
            showPreloader: properties.showPreloader,
            onClick: properties.onSubmit,
            className: 'contactUsForm',
            innerText: properties.translate('submitButton') })),


        _react2.default.createElement('div', { className: styles.requiredTitle },
          properties.translate('requiredField'), ' - ', _react2.default.createElement('span', { className: 'required' }, '*')))));}; // Styles
// Components




var MessageSection = function MessageSection(properties) {return (
    properties.usage === _constants.contactUsUsage.agent || properties.usage === _constants.contactUsUsage.realtorPackages ?
    _react2.default.createElement('div', { className: styles.agentBottomBlock }, bottomBlock(properties)) :

    _react2.default.createElement('div', { className: styles.contentBlock },
      _react2.default.createElement(_reactScroll.Element, { name: 'subject', className: styles.contentRow },
        _react2.default.createElement(_components.OMInputWithLable, {
          title: '' + properties.translate('subjectTitle'),
          name: 'subject',
          placeholder: '' + properties.translate('subjectPlaceholder'),
          field: {
            onChange: properties.handleChange,
            validate: function validate(value) {return !!value;},
            isInvalid: properties.fieldIsInvalid('subject') },

          className: properties.usage === _constants.contactUsUsage.projects ? 'projectsContactUsForm' : 'contactUsForm',
          required: true,
          isRtl: properties.isRtl })),


      _react2.default.createElement(_reactScroll.Element, { name: 'message', className: styles.contentRow },
        _react2.default.createElement(_components.OMInputWithLable, {
          title: '' + properties.translate('messageTitle'),
          name: 'message',
          type: 'textarea',
          placeholder: '' + properties.translate('messagePlaceholder'),
          field: {
            onChange: properties.handleChange,
            validate: function validate(value) {return !!value;},
            isInvalid: properties.fieldIsInvalid('message') },

          className: properties.usage === _constants.contactUsUsage.projects ? 'projectsContactUsForm' : 'contactUsForm',
          required: true,
          isRtl: properties.isRtl })),


      bottomBlock(properties)));};exports.default =



MessageSection;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUsForm/MessageSection.js
// module id = 2645
// module chunks = 0